import Tables from '@/component/Tables';
import PATH from '@/config/PATH';
import { getAuctionRecord } from '@/Redux/futures/account/actions';
import { getDailyPrizeGuesses } from '@/Redux/futures/daily-reward/actions';
import { curStateAccount } from '@/Redux/selector';
import { Table, Text } from '@radix-ui/themes';
import { formatHistoryDate } from '../formatDate';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { NoDataContent } from './NoData';

export default function MyCompete({ active, activeT }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const navigate = useNavigate()
	const [page, setPage] = useState(1);
	const [bidHistory, setBidHistory] = useState([])
	const [dataResApi, setdataResApi] = useState(null)
	const [dataResGuessesApi, setdataResGuessesApi] = useState(null)
	const selectorAccount = useSelector(curStateAccount);
	const [dataResult, setDataResult] = useState([])

	const BID_HISTORY_STATUS = {
		BIDING: t('account_page.auction_record_page.status_success'),
		FAIL: t('account_page.auction_record_page.status_fail'),
		DEALED: t('account_page.auction_record_page.status_dealed'),
	};

	const afterGetBidHistory = (data, isLoading) => {
		if (data) {
			setdataResApi(data)
			setBidHistory(data.data)
		}
	}

	const getCurrentPayload = (page) => {
		if (page === 1) {
			return 0;
		}
		return page;
	};

	const afterDailyPrizeGuesses = (data, isLoading) => {
		if (data) {
			setdataResGuessesApi(data)
		}
	};

	const getBidHistoryPage = () => {
		if (active === 'weekly') {
			const body = {
				query: {
					pageSize: 10,
					current: getCurrentPayload(page),
				},
				callback: afterGetBidHistory
			}
			dispatch(getAuctionRecord(body))
		} else {
			const body = {
				query: {
					page: page,
					limit: 10,
					scope: "me",
				},
				callback: afterDailyPrizeGuesses,
			};
			dispatch(getDailyPrizeGuesses(body))
		}
	}

	useEffect(() => {
		getBidHistoryPage()
	}, [page, activeT, active]);


	const bidHistoriesFilter = bidHistory?.data?.map(
		(bidHistorie) => bidHistorie
	);
	const resultsFilter = dataResult
		?.filter((result) => result?.id === selectorAccount?.userInfo?.id)
		?.map((item) => item?.auction_price);

	const dealedArr = resultsFilter
		?.map((el) => bidHistoriesFilter?.find((item) => item?.price === el))
		?.map((item) => item?.key);

	const columns = [
		{ key: "product_name", title: t('account_page.auction_record_page.name'), },
		{ key: "product_code", title: t('account_page.auction_record_page.code'), },
		...(active === 'weekly'
			? [{ key: "product_price", title: t('account_page.auction_record_page.market_price') }]
			: []),
		{ key: "price", title: t('account_page.auction_record_page.bid_price') },
		{ key: "auction_time", title: t('account_page.auction_record_page.bid_time') },
		{ key: "status", title: t('account_page.auction_record_page.status') },
	];

	useEffect(() => {
		setPage(1);
	}, [active, activeT]);

	const handleClickButtonNodata = () => {
		active === 'weekly' ? navigate(PATH.HOME) : navigate(PATH.DAILY_REWARD)
	}

	const isDaily = active === 'daily';

	const isEmpty = isDaily
		? dataResGuessesApi?.data?.items?.length === 0
		: dataResApi?.data?.length === 0;

	return (
		<>
			{
				(isEmpty == null || isEmpty) ?
					<NoDataContent
						title={t("no_wins_yet")}
						textBtn={t("guess_price")}
						describe={t("you_haven't_guess_any_price")}
						handleClick={handleClickButtonNodata}
					/>
					:
					<>
						{active === 'weekly' ?
							<>
								<Tables
									fill
									current={page}
									onChange={(p) => setPage(p)}
									columns={columns}
									pagination={true}
									data={dataResApi?.data || []}
									totalPages={Math.ceil((dataResApi?.total || 0) / Number(dataResApi?.pageSize || 1))}
									renderRow={(item, index) => (
										<Table.Row key={item.id + index + 1}>
											<Table.Cell>
												<div className="flex items-center h-full text-left gap-1">
													<img
														src={item.product_image?.split(",")[0]}
														alt=""
														className="w-12 h-12 rounded-3xl object-cover"
													/>
													<Text className="max-w-[220px] flex items-center font-medium text-[rgba(113,59,18,1)]">{item.product_name}</Text>
												</div>
											</Table.Cell>
											<Table.Cell >
												<div className="max-w-[220px] flex items-center h-full text-left">
													<Text className="font-medium text-[rgba(113,59,18,1)]">{item.product_code}</Text>
												</div>
											</Table.Cell>
											<Table.Cell>
												<div className="flex items-center h-full text-left">
													<Text className="flex items-center font-medium text-[rgba(113,59,18,1)]">{item?.product_price?.toLocaleString("en-US")} MMK</Text>
												</div>
											</Table.Cell>
											<Table.Cell>
												<div className="flex items-center h-full text-left">
													<Text className="font-medium text-[rgba(113,59,18,1)]">{item?.price?.toLocaleString("en-US")} MMK</Text>
												</div>
											</Table.Cell>
											<Table.Cell>
												<div className="flex items-center h-full text-left">
													<Text className="font-medium text-[rgba(113,59,18,1)]">{formatHistoryDate(item.auction_time)}</Text>
												</div>
											</Table.Cell>
											<Table.Cell>
												<div className="flex items-center h-full text-left font-medium text-[rgba(113,59,18,1)]">
													{dealedArr?.includes(index)
														? BID_HISTORY_STATUS.DEALED
														: BID_HISTORY_STATUS.BIDING}
												</div>
											</Table.Cell>
										</Table.Row>
									)}
								/>
							</>
							:
							<>
								<Tables
									fill
									current={page}
									onChange={(p) => setPage(p)}
									columns={columns}
									pagination={true}
									data={dataResGuessesApi?.data?.items || []}
									totalPages={Math.ceil((dataResGuessesApi?.data?.total || 0) / Number(dataResGuessesApi?.data?.limit || 1))}
									renderRow={(item, index) => (
										<Table.Row key={item.id + index + 1}>
											<Table.Cell>
												<div className="flex items-center h-full text-left gap-1">
													<img
														src={item?.illustrative_item?.image_url?.split(",")[0]}
														alt=""
														className="w-12 h-12 rounded-3xl object-cover"
													/>
													<Text className="max-w-[220px] flex items-center font-medium text-[rgba(113,59,18,1)]">{item?.illustrative_item?.name}</Text>
												</div>
											</Table.Cell>
											<Table.Cell >
												<div className="max-w-[220px] flex items-center h-full text-left">
													<Text className="font-medium text-[rgba(113,59,18,1)]">{item?.illustrative_item?.product_code}</Text>
												</div>
											</Table.Cell>
											<Table.Cell>
												<div className="flex items-center h-full text-left">
													<Text className="font-medium text-[rgba(113,59,18,1)]">{item?.guess_price?.toLocaleString("en-US")} MMK</Text>
												</div>
											</Table.Cell>
											<Table.Cell>
												<div className="flex items-center h-full text-left">
													<Text className="font-medium text-[rgba(113,59,18,1)]">{formatHistoryDate(item.auction_time || item.created_at)}</Text>
												</div>
											</Table.Cell>
											<Table.Cell>
												<div className="flex items-center h-full text-left font-medium text-[rgba(113,59,18,1)]">
													{dealedArr?.includes(index)
														? BID_HISTORY_STATUS.DEALED
														: BID_HISTORY_STATUS.BIDING}
												</div>
											</Table.Cell>
										</Table.Row>
									)}
								/>
							</>
						}
					</>
			}
		</>
	)
}
